/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 0446928955970b59719768048eafdff2 */

import { ConcreteRequest } from "relay-runtime";

export type SourceAttributionInput = {
    guestUserId?: string | null | undefined;
    landingPage?: string | null | undefined;
    type: string;
    userId: string;
    userToken?: string | null | undefined;
    emailToken?: string | null | undefined;
    visitCount?: number | null | undefined;
    pageVisits?: Array<pageVisits | null> | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type pageVisits = {
    date?: string | null | undefined;
    type?: string | null | undefined;
    utmParams?: utmParams | null | undefined;
};
export type utmParams = {
    landingPage?: string | null | undefined;
    visitCount?: number | null | undefined;
};
export type sourceAttributionMutationVariables = {
    input: SourceAttributionInput;
};
export type sourceAttributionMutationResponse = {
    readonly sourceAttribution: {
        readonly message: string | null;
    } | null;
};
export type sourceAttributionMutation = {
    readonly response: sourceAttributionMutationResponse;
    readonly variables: sourceAttributionMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "SourceAttributionPayload",
            "kind": "LinkedField",
            "name": "sourceAttribution",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "message",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "sourceAttributionMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutations",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "sourceAttributionMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "id": "ferrum/352.0.0-2022-02-11T14:31:47.735Z/sourceAttributionMutation",
            "metadata": {},
            "name": "sourceAttributionMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '0776fc099f129d46b7995c62aa8613ee';
export default node;
